export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const WEB_URL = process.env.REACT_APP_WEB_URL;
